import request from "@/util/http"; // 获取权责分页

export var homeChargePage = function homeChargePage(params) {
  return request({
    url: "/admin/homeCharge/getChargePage",
    method: "get",
    params: params
  });
}; // 获取关联部门列表

export var homeChargeDeptList = function homeChargeDeptList(params) {
  return request({
    url: "/admin/homeCharge/getDeptList",
    method: "get",
    params: params
  });
}; // 获取部门树

export var homeChargeDeptTree = function homeChargeDeptTree() {
  return request({
    url: "/admin/homeCharge/getDeptTree",
    method: "get"
  });
}; // 获取服务分类

export var homeChargeServeVoList = function homeChargeServeVoList() {
  return request({
    url: "/admin/homeCharge/getServeVoList",
    method: "get"
  });
};